import { Controller, useForm } from 'react-hook-form'
import { ProductTicketAreaVM } from '../../../../../core/types/Tickets'
import { useEffect } from 'react'
import SwipeableDrawerRightDialog from '../../../../../components/Dialogs/SwipeableDrawerRightDialog'
import { Box, Grid, TextField } from '@mui/material'

export default function ProductTicketAreaDialog({
  open,
  initial,
  onClose,
  onSubmit,
}: {
  open: boolean
  initial: ProductTicketAreaVM
  onClose: () => void
  onSubmit: (a: ProductTicketAreaVM) => void
}) {
  const { control, handleSubmit, reset } = useForm<ProductTicketAreaVM>({
    defaultValues: initial,
    mode: 'onBlur',
  })

  useEffect(() => {
    // Atualiza valores quando o initial mudar
    reset(initial)
  }, [initial])

  return (
    <SwipeableDrawerRightDialog
      open={open}
      setOpen={(_) => onClose()}
      onClose={onClose}
      title="Área"
      subtitle="Defina as configurações da área"
      buttons={[
        { title: 'Cancelar', type: 'negative', onClick: onClose },
        {
          title: 'Continuar',
          type: 'positive',
          onClick: handleSubmit(onSubmit),
        },
      ]}
    >
      <Box sx={{ p: 2 }}>
        <Grid container spacing={2} sx={{ pt: 1 }}>
          <Grid item xs={12} md={6}>
            <Controller
              name="name"
              control={control}
              rules={{ required: 'O nome é obrigatório' }}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  size="small"
                  label="Nome"
                  fullWidth
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <Controller
              name="displayOrder"
              control={control}
              rules={{
                required: 'A ordem é obrigatória.',
                min: {
                  value: 1,
                  message: 'A ordem deve ser no mínimo 1.',
                },
              }}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  size="small"
                  type="number"
                  label="Ordem"
                  fullWidth
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <Controller
              name="capacity"
              control={control}
              rules={{
                required: 'A capacidade é obrigatória.',
                min: {
                  value: 0,
                  message: 'A capacidade deve ser no mínimo 0.',
                },
              }}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  size="small"
                  type="number"
                  label="Capacidade"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  size="small"
                  label="Descrição/Benefícios"
                  fullWidth
                />
              )}
            />
          </Grid>
        </Grid>
      </Box>
    </SwipeableDrawerRightDialog>
  )
}
